<template>
  <v-app>
    <v-container>
      <v-toolbar>
        <v-toolbar-title>Support Currency-One</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn v-if="token" @click="$refs.auth.signOut()" text>Wyloguj</v-btn>
        <v-btn v-else @click="$refs.auth.signIn()" text>Zaloguj</v-btn>
        <Auth ref="auth" @token="token = $event"></Auth>
      </v-toolbar>

      <v-progress-linear v-if="token && !teams" indeterminate></v-progress-linear>

      <v-flex v-if="teams">
            <v-card flat v-for="(team, team_index) in teamsToShow" :key="team.name">
              <v-card-title primary-title v-on:click="switchShowAll(team_index)">
                <h4 class="display-1">
                  {{ team.name }}&nbsp;
                </h4>
                <h6 class="headline">
                  {{ team.desc }}
                </h6>
                <v-divider></v-divider>
                <template v-if='team.people.length > 1'>
                  <v-icon v-if="!team.showMoreThanOne" x-large>mdi-chevron-down</v-icon> 
                  <v-icon v-else x-large>mdi-chevron-up</v-icon> 
                </template>
              </v-card-title>

              <v-card-text>
                <v-layout row>
                    <v-container>
                      <v-row v-if=team.isNoOneOnSupport>
                          <v-col cols="12" xs="12" md="12" :key=team.name >
                            <h6 class="headline red">
                              Nikt z tego zespołu nie jest na supporcie - osoby wymienione poniżej nie spodziwają się kontaktu
                            </h6>
                          </v-col>
                      </v-row>
                      <v-row>
                        <template v-for="person in (team.showMoreThanOne ? team.people : team.people.slice(0,1))">
                          <v-col  cols="12" xs="4" md="4" :key=person.email >
                              <v-container>
                                <v-row>
                                  <v-col cols="12" xs="12">
                                    {{ person.fullName }}
                                  </v-col>
                                  </v-row>
                                  <v-row>
                                  <v-col cols="12" xs="12">
                                    <a :href = "`mailto:${ person.email }`" :style="{'text-decoration': 'none' }"><v-icon>mail</v-icon> {{ person.email }}</a>
                                  </v-col>
                                  </v-row>
                                  <v-row>
                                  <v-col cols="12" xs="12">
                                  <a :href = "`tel:${ person.phone }`" :style="{'text-decoration': 'none' }"><v-icon>phone</v-icon> {{ person.phone | formatPhone }}</a>
                                  </v-col>
                                </v-row>
                              </v-container>
                          </v-col>
                        </template>
                      </v-row>
                    </v-container>
                </v-layout>
              </v-card-text>
            </v-card>
      </v-flex>
    </v-container>
  </v-app>
</template>

<script>
import got from 'got'
import Auth from '@/components/Auth'

export default {
  name: 'App',
  components: { Auth },

  data() {
    return {
      teams: null,
      personDetails: null,
      token: true,
      teamsToShow: [
        {
          key: 'helpdesk_team_schedule',
          name: 'Helpdesk',
          desc: 'Problemy ze sprzętem',
        },
        {
          key: 'ops_team_schedule',
          name: 'Infrastruktura',
          desc: '',
        },
        {
          key: 'wt3_team_schedule',
          name: 'Walutomat (WT)',
          desc: '',
        },
        {
          key: 'ikwt_team_schedule',
          name: 'Internetowy Kantor (IK)',
          desc: '',
        },
        {
          key: 'Ruby_team_schedule',
          name: 'Domena Bankowa',
          desc: 'Problemy z wprowadzaniem przelewów, sczytywaniem stanu kont',
        },
        {
          key: 'sec_schedule',
          name: 'Security',
          desc: '',
        },
        {
          key: 'bi_team_schedule',
          name: 'Business Intelligence',
          desc: '',
        },
      ],
    }
  },

  methods: {
    switchShowAll: function (i) {
      this.teamsToShow[i].showMoreThanOne = !this.teamsToShow[i].showMoreThanOne
    }
  },

  filters: {
    formatPhone(phone) {
      if (!phone || !phone.match(/48\-\d+/)) {
        return phone
      }
      return (
        '+48 ' +
        phone
          .split('-')[1]
          .match(/(\d{1,3})/g)
          .join(' ')
      )
    },
  },

  watch: {
    async token() {
      if (!this.token) {
        this.$refs.auth.signIn()
        return
      }
      const headers = {
        Authorization: `Bearer ${this.token}`,
      }
      const url = 'https://us-central1-who-is-on-support.cloudfunctions.net/onCall'
      const res = await got(url, { json: true, headers })
      this.teams = res.body.onCall
      this.personDetails = res.body.personDetails
      const onCall = Object.fromEntries(this.teams)
      this.teamsToShow = this.teamsToShow.map((team) => {
        const emails = onCall[team.key]
        const isNoOneOnSupport = emails.length === 0
        const people = !isNoOneOnSupport ? emails : res.body.teamParticipants[team.key]
        return {
          ...team,
          people: people.map((email) => ({ ...res.body.personDetails[email], email })),
          isNoOneOnSupport,
          showMoreThanOne: false,
        }
      })
      
    },
  },

  mounted() {
    document.title = 'C1 Support'
  },
}
</script>


<style lang="stylus">

.v-list__tile__content
  user-select text

</style>
